jQuery(document).ready(function($) {
	// Get Window Width and Height
	var windowWidth = $(window).outerWidth();
    var windowHeight = $(window).height();
});

/* Document ready functions */

jQuery(window).resize(function ($) {
    // Get Window Width and Height on resize
    windowWidth = $(window).outerWidth();
    windowHeight = $(window).height();
});

jQuery(document).ready(function ($) {
    windowWidth = $(window).outerWidth();
    if (windowWidth < 1023) {
        $('.menu_btn').on('click', function(){
            if($('html, body').hasClass('navOpen')) {
                $('html, body').removeClass('navOpen');
            } else {
                $('html, body').addClass('navOpen');
            }
        });
    }
});
    

    
jQuery(document).ready(function ($) {
    $('.menu-section .menu-item-has-children').on('click', function() {
        $(this).children().last().slideToggle();
    });
});


// Scroll down click event

jQuery(document).ready(function($) {
    $(".living .scroll-down").click(function(event){
        $('html, body').animate({scrollTop: '+=400px'}, 800);
    });
});